import React, { useState } from "react";
import { Container, Row, Col, Card, CardHeader, Button, CardBody } from "reactstrap";
import { useTranslation } from "context/TranslationProvider";
import BlockedIPs from "./components/BlockedIPs";
import helpers from "../../../utils/helpers";
import { Link } from "react-router-dom";

const SettingsPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("securitySetting");

  const tabs = helpers.getTabs(t);

  return (
    <Container className="mt-4">
      <Row>
        <Col md="4">
          <Card>
            <CardHeader>{t("page.settings.tabs.title", "Settings Tabs")}</CardHeader>
            <CardBody>
              {tabs.map((tab) => (
                <Button
                  key={tab.key}
                  color={activeTab === tab.key ? "primary" : "secondary"}
                  block
                  className="mb-3 ml-0"
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </Button>
              ))}
            </CardBody>
          </Card>
        </Col>

        <Col md="8">
          <Card>
            <CardHeader>{helpers.getCardHeader(activeTab, t)}</CardHeader>

            {activeTab === "securitySetting" && <BlockedIPs />}
          </Card>
          <div className="mt-3 ml-2">
            <Link
              to="/admin/failedLogin"
              className="view-blocked-link"
            >
              {t(
                "page.blockedIps.viewBlocked",
                "View Blocked IPs and Failed Login Attempts"
              )}
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SettingsPage;
